import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { Feature } from "geojson";

import React, { Component } from "react";
import { classes } from "typestyle";
import { MAPBOX_SATELLITE } from "../../../../leafletControls/MapBaseLayersControl";
import {
  mapAndControlsContainerCN,
  mapAndControlsContainerCollapsedCN,
  mapContainerCN,
} from "./styles";

interface GeoJsonViewerProps {
  value?: Feature;
}

interface GeoJsonViewerState {
  map: L.Map | null;
}

export default class GeoJsonViewer extends Component<
  GeoJsonViewerProps,
  GeoJsonViewerState
> {
  mapContainer = React.createRef<HTMLDivElement>();
  polygonLayer: L.Layer | null;

  UNSAFE_componentWillMount() {
    this.setState({
      map: null,
    });
    this.polygonLayer = null;
  }

  componentDidMount() {
    this.setState(
      {
        map: L.map(this.mapContainer.current as HTMLDivElement, {
          zoomControl: false,
          scrollWheelZoom: false,
        }).setView([50, 50], 3),
      },
      () => {
        if (this.state.map != null) {
          L.tileLayer(MAPBOX_SATELLITE.tilesUrl).addTo(this.state.map);
        }
      },
    );
  }

  componentDidUpdate() {
    this.renderPolygon();
  }

  render() {
    return (
      <div
        className={classes(
          mapAndControlsContainerCN,
          mapAndControlsContainerCollapsedCN,
        )}
      >
        <div className={mapContainerCN} ref={this.mapContainer} />
      </div>
    );
  }

  renderPolygon() {
    const map = this.state.map;
    const polygonLayer = this.polygonLayer;

    if (!map) {
      return null;
    }

    if (polygonLayer && map.hasLayer(polygonLayer)) {
      map.removeLayer(polygonLayer);
    }

    const newPolygonLayer = L.geoJSON(this.props.value);
    map.addLayer(newPolygonLayer);
    map.fitBounds(newPolygonLayer.getBounds());

    this.polygonLayer = newPolygonLayer;
  }
}
